<!--
@component
TeamsPage

Route page component.
-->

<script lang="ts">
  import parseSeo from '$utils/parseSeo';
  import { appState } from '$lib/stores/index.svelte';
  import getPath from '$utils/getPath';

  import Page from '$lib/components/TeamPage/index.svelte';
  // import SEO from '$lib/components/common/SEO/SEO.svelte';

  /* Matches data from API */
  let { data } = $props();

  const content = $derived(data.content);

  /* Prefer the team loaded in `+layout.js` (always available during SSR /
     prerender). Fall back to the active country resolved through the
     global `appState.teams` (a `$derived` of `appState.optaData`) so SPA
     navigation always reads against the freshest data. See #67. */
  const activeTeam = $derived(
    data.team ||
      (appState.activeCountry.length && appState.activeCountry[0] ?
        appState.teams.getTeam(appState.activeCountry[0].name)
      : null)
  );

  const teamName = $derived(activeTeam?.name ?? '');
  const teamSlug = $derived(activeTeam?.slug ?? '');

  const seo = $derived(parseSeo(content, 'team-seo', { teamName, teamSlug }));
</script>

<!-- <SEO {seo} /> -->

<Page data={appState.optaData} team={data.team} squad={data.squad} />

<svelte:head>
  <link
    rel="preload"
    as="image"
    href={getPath('images/flags/rects/UNKNOWN.png')}
  />
  <link
    rel="preload"
    as="image"
    href={getPath('images/flags/circles/UNKNOWN.png')}
  />

  {#each data.teams as team}
    <link
      rel="preload"
      as="image"
      href={getPath(`images/flags/rects/${team.slug}.png`)}
    />
    <link
      rel="preload"
      as="image"
      href={getPath(`images/flags/circles/${team.slug}.png`)}
    />
  {/each}
</svelte:head>
